// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputsSearch {
  display: none;
}
.inputsSearch .inputSearch {
  display: none;
}
.inputsSearch .selectSearch {
  display: none;
}

.inputsSearchDesktop {
  margin-top: 2rem;
}
.inputsSearchDesktop .inputSearch {
  width: 35%;
}
.inputsSearchDesktop .selectSearch {
  width: 40%;
}

@media (min-width: 300px) and (max-width: 600px) {
  .inputsSearch {
    display: block;
  }
  .inputsSearch .inputSearch {
    display: block;
    width: 45%;
  }
  .inputsSearch .selectSearch {
    display: block;
    width: 50%;
  }
  .inputsSearchDesktop {
    display: none;
  }
  .inputsSearchDesktop .inputSearch {
    display: none;
  }
  .inputsSearchDesktop .selectSearch {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/career-map/glosarry.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AACI;EACI,aAAA;AACR;AACI;EACI,aAAA;AACR;;AAEA;EACI,gBAAA;AACJ;AAAI;EACI,UAAA;AAER;AAAI;EACI,UAAA;AAER;;AAEA;EACI;IACI,cAAA;EACN;EACM;IACI,cAAA;IACA,UAAA;EACV;EACM;IACI,cAAA;IACA,UAAA;EACV;EAEE;IACI,aAAA;EAAN;EACM;IACI,aAAA;EACV;EACM;IACI,aAAA;EACV;AACF","sourcesContent":[".inputsSearch {\n    display: none;\n\n    .inputSearch {\n        display: none;\n    }\n    .selectSearch {\n        display: none;\n    }\n}\n.inputsSearchDesktop {\n    margin-top: 2rem;\n    .inputSearch {\n        width: 35%;\n    }\n    .selectSearch {\n        width: 40%;\n    }\n}\n\n@media (min-width: 300px) and (max-width: 600px) {\n    .inputsSearch {\n        display: block;\n\n        .inputSearch {\n            display: block;\n            width: 45%;\n        }\n        .selectSearch {\n            display: block;\n            width: 50%;\n        }\n    }\n    .inputsSearchDesktop {\n        display: none;\n        .inputSearch {\n            display: none;\n        }\n        .selectSearch {\n            display: none;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
